<template>
    <mobile-card>
        <template slot="title">订单明细</template>
        <template slot="content">
            <div v-if="showPendFees">
                <div v-for="(item,index) in detail.pendFees" :key="index" class="flex-form-info">
                    <span>{{`${item.itemName}`}}<span v-if="item.intervalId!=0">{{`（${item.intervalName}）`}}</span></span>
                    <span class="money-item">{{item.nowMoney | formatMoney}}</span>
                </div>
            </div>
            <div class="border-bottom-solid"></div>
            <div class="flex-form-info">
                <span>学号：</span>
                <span>{{detail.userCode}}</span>
            </div>
            <div class="border-bottom-solid"></div>

            <div class="flex-form-info">
                <span>名称：</span>
                <span>{{detail.userName}}</span>
            </div>
            
            <div class="border-bottom-solid"></div>
            <div class="flex-form-info" v-if="showRemark">
                <span>备注信息：</span>
            </div>
            <div class="flex-form-info" v-if="showRemark">
                <span>{{detail.pendFees[0].itemRemark}}</span>
            </div>

            <!-- <div class="flex-form-info" v-if="showChooseFee">
                <span>{{detail.chooseFee.itemName}}</span>
                <span>{{detail.chooseFee.intervalName}}</span>
                <span class="money-item">{{detail.allMoney | formatMoney}}</span>
            </div> -->
        </template>
    </mobile-card>
</template>
<script>

    import mobileCard from "components/mobile-card/index"

    export default {
        name: "ticketDetail",
        props: {
            detail: Object,
        },
        computed: {
            showPendFees() {
                return Array.isArray(this.detail.pendFees)
            },
            showChooseFee() {
                return this.detail.chooseFee != null
            },
            showRemark(){
                return this.detail.pendFees[0].itemRemark != null && this.detail.pendFees[0].itemRemark != ''
            }
        },
        data() {
            return {
                infoList: [
                    {
                        name: "姓名",
                        value: "12345",
                    },
                    {
                        name: "姓名",
                        value: "12345",
                    },
                    {
                        name: "姓名",
                        value: "12345",
                        valueClass: "money-item",
                        filter: "",
                    },
                ],
            }
        },
        components: {
            mobileCard,
        },
        methods: {},
        created() {
        },
    }
</script>
<style lang="scss" scoped>
    /*.flex-form-info {*/
    /*    padding: 5px;*/
    /*    display: flex;*/
    /*    justify-content: space-between;*/
    /*}*/

    /*.flex-detail {*/
    /*    justify-content: space-between;*/
    /*}*/

    /*.money-item {*/
    /*    color: #3b7a53;*/
    /*}*/
    .border-bottom-solid {
        border-bottom: 1px dashed #d3d3d3;
        margin-left: 10px;
        margin-right: 10px;
    }
</style>
